import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Marquee from '../components/Marquee';
import Navbar from '../components/Navbar';
import BannerCarousel from '../components/BannerCarousel';
import BentoGrid from '../components/BentoGrid';
import BrandsMarqueeStrip from '../components/BrandsMarqueeStrip';
import Footer from '../components/Footer';
import FeaturedMediaSection from '../components/FeaturedMediaSection';
import ReelsRow from '../components/ReelsRow';
import FAQSection from '../components/FAQSection';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
    }
  }, [location]);

  return (
    <div id="home">
      <Marquee />
      <Navbar />
      <BannerCarousel />
      <BentoGrid />
      <ReelsRow />
      <BrandsMarqueeStrip />
      <FeaturedMediaSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default Home;
